// #tag: HOMEPAGE SCREEN
// #purpose: Renders the primary landing page assembled dynamically from CMS section layouts, banners, search modules, and featured exams.
import React from 'react';
import { ErrorState, LoadingState } from '../components/states/StateViews';
import { HomePageSections } from '../components/cms/PageSections';
import { usePageSections } from '../hooks/useExamData';

export function HomeScreen() {
  const { data, isLoading, isError, refetch } = usePageSections('home');
  const sections = data?.data ?? [];

  if (isLoading) {
    return (
      <section className="adaptive-page">
        <LoadingState label="Loading homepage…" />
      </section>
    );
  }

  if (isError) {
    return (
      <section className="adaptive-page">
        <ErrorState message="Could not load homepage content." onRetry={() => refetch()} illustrationContext="error.network" />
      </section>
    );
  }

  return <HomePageSections sections={sections} />;
}
